export default __webpack_public_path__ + "static/media/blurred-dude.a30b7e42.jpg";